import * as React from 'react';
import DashboardLayout from '../Layouts/DashboardLayout';
import {
  PortfolioBg,
  PortfolioBounds,
  PortfolioGrid,
  PortfolioSlider,
} from '../../components/Portfolio/PortfolioUI';
import portfolioData from '../../data/portfolioData';
import PortfolioBox from './PortfolioBox';

const Portfolio: React.SFC = () => (
  <DashboardLayout>
    <PortfolioBg>
      <PortfolioSlider>
        <PortfolioBounds>
          <PortfolioGrid>
            {portfolioData.map(portfolio => (
              <PortfolioBox key={Math.random()} portfolio={portfolio} />
            ))}
          </PortfolioGrid>
        </PortfolioBounds>
      </PortfolioSlider>
    </PortfolioBg>
  </DashboardLayout>
);

export default Portfolio;



// WEBPACK FOOTER //
// ./src/containers/Portfolio/Portfolio.tsx